import $ from "jquery"

export function initSelect2Baremo($select) {
  if ($select.data("select2")) {
    $select.select2("destroy")
  }

  $select.select2({
    theme: "bootstrap",
    minimumInputLength: 1, // Requiere al menos 1 carácter antes de buscar
    language: {
      inputTooShort: function (args) {
        var remainingChars = args.minimum - args.input.length
        return "Ingrese " + remainingChars + " letra o más para comenzar la búsqueda"
      },
      noResults: function () {
        return "No se encontraron resultados, por favor inténtelo nuevamente."
      }
    },
    matcher: function (params, data) {
      // Filtra las opciones localmente en función de la entrada del usuario
      if (data.text.toLowerCase().indexOf(params.term.toLowerCase()) > -1) {
        return data
      }
      return null
    }
  })
}
